<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="16">
        <el-form ref="formData" :model="formData" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                :label="$l('label_supplier') || '所属供应商'"
                prop="scmCode"
              >
                <dict-select
                  :disabled="isLocked"
                  clearable
                  filterable
                  v-model="formData.scmCode"
                  size="medium"
                  url="/digitalCenter/common/dict/scmInfoDict"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$l('label_file_desc') || '文件说明'">
                <el-input
                  v-model="formData.scmImageDesc"
                  type="textarea"
                  :rows="3"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-3">
      <el-col :span="12">
        <span>支持上传jpg/png/jpeg/gif/pdf/doc/xls文件</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-upload
          list-type="text"
          :auto-upload="false"
          ref="pictureUpload"
          action="/oss/ossUploadReturnUrlAndFileId"
          :data="fileData"
          :headers="fileHeaders"
          :limit="maxLimit"
          :on-change="onChange"
          :on-remove="onChange"
          :on-success="onSuccess"
          :on-error="onError"
          :before-upload="beforeUpload"
          :disabled="uploadValidate"
          multiple
          accept=".jpeg,.jpg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx"
        >
          <el-button size="small" type="primary">{{ $l('tips_add_file') || '上传文件' }}</el-button>
          <div slot="tip" class="el-upload__tip"><p v-if="!uploadValidate">
            {{ $l('tips_uploadUp') || '最多上传' }}{{ maxLimit
            }}{{ $l('tips_file') || '个文件' }}
          </p>
          <p v-else>
            {{ $l('tips_mqr') || '已达最大上传数量' }}
          </p></div>
          <!-- <i slot="default" class="el-icon-plus" v-if="!uploadValidate"></i>
          <i
            slot="default"
            class="el-icon-remove-outline"
            v-else
            style="color: #ef1944"
          ></i>

          <p class="upload-text-true" v-if="!uploadValidate">
            {{ $l('tips_uploadUp') || '最多上传' }}{{ maxLimit
            }}{{ $l('tips_file') || '个文件' }}
          </p>
          <p class="upload-text-false" v-else>
            {{ $l('tips_mqr') || '已达最大上传数量' }}
          </p> -->
        </el-upload>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <div class="d2-mt d-flex justify-content-end">
      <el-row>
        <el-col :span="24">
          <el-button @click="upload" type="primary" size="small">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
          <el-button @click="uploadClearFiles" size="small">{{
            $l('btn_emptyFile') || '清空图片'
          }}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import util from '@/libs/util'
export default {
  components: {},
  data() {
    return {
      isLocked: false,
      imageTypeList: ['image/jpeg', 'image/png', 'image/jpg', 'image/gif','application/pdf'
      ,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ,'application/vnd.ms-excel'
      ,'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ,'application/msword'],
      maxLimit: 10, // 最大上传次数
      uploadValidate: false, // 是否允许上传
      uploadSize: 0, // 本次选中上传文件次数，每次上传后减1
      formData: {
        scmCode: '',
        imageDataList: [],
      },
      fileData: {
        // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken(),
      },
      dialogImageUrl: '', // 点击查看大图url
      dialogVisible: false, // 查看大图弹出框
      rules: {
        scmCode: [
          {
            required: true,
            message: this.$l('visit_form_rule_scmCode') || '请选择所属供应商',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    init(scmCode) {
      this.reset(scmCode)

      if (scmCode != null && scmCode != '') {
        this.isLocked = true
      } else {
        this.isLocked = false
      }
    },
    // 上传前
    beforeUpload(file) {
      let index = this.imageTypeList.indexOf(file.type)
      if (index < 0) {
        return false
      } else {
        return true
      }
    },
    // 上传成功
    onSuccess(res) {
      this.uploadSize--
      if (res.status === 200) {
        let imageData = {
          scmImageCode: res.body.fileId,
          scmThumbImageCode: res.body.thumbnailFileId,
          scmThumbImageUrl: res.body.thumbnailUrl,
          scmImageUrl: res.body.url,
        }
        this.formData.imageDataList.push(imageData)
      }
      if (this.uploadSize === 0) {
        this.save()
      }
    },
    // 上传失败
    onError() {
      this.uploadSize--
      if (this.uploadSize === 0) {
        this.save()
      }
    },
    // 文件删除
    handleRemove(file) {
      this.$refs.pictureUpload.handleRemove(file)
    },
    // 文件查看
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 文件列表有变动触发
    onChange() {
      if (this.$refs.pictureUpload.uploadFiles.length >= this.maxLimit) {
        this.uploadValidate = true
      } else {
        this.uploadValidate = false
      }
    },
    // 上传图片
    upload() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.$refs.pictureUpload.uploadFiles.length <= 0) {
            this.$message.warning(this.$l('tips_putp_file') || '请上传文件')
            return false
          }
          this.uploadSize = this.$refs.pictureUpload.uploadFiles.length
          this.$refs.pictureUpload.submit()
        }
      })
    },
    // 清空全部图片
    uploadClearFiles() {
      this.$refs.pictureUpload.clearFiles()
      this.uploadValidate = false
    },
    save() {
      if (this.formData.imageDataList.length <= 0) {
        this.$message.error(
          this.$l('tips_fileUploadFailed') ||
            '文件上传失败，没有获得文件数据'
        )
        return false
      }
      this.$api.scmInfoImageBatchAddApi(this.formData).then(() => {
        this.$message({
          showClose: true,
          message: this.$l('tips_save_ok') || '保存成功',
          type: 'success',
        })
        this.$emit('uploadImageSuccess')
        this.$emit('supplierImageSuccess')
      })
    },
    reset(scmCode) {
      this.maxLimit = 10 // 最大上传次数
      this.uploadValidate = false // 是否允许上传
      this.uploadSize = 0 // 本次上传次数
      this.formData = {
        scmCode: scmCode,
        imageDataList: [],
      }
      this.dialogImageUrl = ''
      this.dialogVisible = false
      this.$refs.formData.resetFields()
      this.uploadClearFiles()
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-text-true {
  line-height: normal;
  margin-top: -30px;
  font-size: 5px;
  color: #8c939d;
}
.upload-text-false {
  line-height: normal;
  margin-top: -30px;
  font-size: 5px;
  color: #ef1944;
}
.imgbox {
  border: 1px solid #dcdfe6;
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 4px;
  float: left;
}
.imgbox img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>
